<template>
  <div class="container" style="max-width:600px;margin:40px auto;padding:20px">
    <h2>Verificação de e-mail</h2>

    <div v-if="status === 'loading'">
      Validando seu e-mail, aguarde...
    </div>

    <div v-else-if="status === 'ok'">
      <p>✅ E-mail validado com sucesso!</p>
      <router-link to="/login">Ir para o login</router-link>
    </div>

    <div v-else>
      <p>❌ {{ errorMessage }}</p>
      <router-link to="/login">Voltar ao login</router-link>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import jwt from "jsonwebtoken";

export default {
  name: "VerifyEmail",
  data: () => ({
    status: "loading",
    errorMessage: "",
  }),
  methods: {
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    async validarEmail() {
      let token = "";
      let setDB = "";

      // decoded do token jwt
      jwt.verify(
        this.$route.query.token,
        process.env.VUE_APP_JWT_SECRET,
        (err, decoded) => {
          if (decoded) {
            token = decoded.token;
            setDB = decoded.setDB;
          }
        }
      );
      const th = this;

      if (!token) {
        th.showSwal("auto-close", "Erro", "Token não informado!", "error");
        return;
      }
      if (!setDB) {
        th.showSwal(
          "auto-close",
          "Erro",
          "Banco de Dados não informado!",
          "error"
        );
        return;
      }

      const bodyFormData = {
        setDB,
        token,
      };
      this.axios
        .post("/api/empregado/validarEmail", bodyFormData)
        .then((response) => {
          if (response.data.status == "success") {
            th.status = "ok";
          } else {
            th.status = "error";
            th.errorMessage = "Falha na validação do e-mail.";
          }
        })
        .catch((err) => {
          th.status = "error";
          th.errorMessage = "Erro inesperado ao validar o e-mail";
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro inesperado ao validar o e-mail",
            "error"
          );
        });
    },
  },
  async created() {
    await this.validarEmail();
  },
};
</script>
